// controller
import useGetData from "../../../hook/getData";
import { GetComments } from "../../../services/panel/comments/getComments";

const Comments = () => {
    const { data: comments } = useGetData(['userComments'], GetComments)
    return (
        <>
            <div className="card card-body shadow border-1 rounded rounded-4">
                <div className="rounded box-site rounded-4 d-flex justify-content-between align-items-center py-3 mb-0">
                    <span>نظرات</span>
                </div>
                <div className="table-responsive mt-4">
                    <table className="table table-bordered text-center font-medium align-middle">
                        <thead>
                            <tr>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>متن کامنت</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>ردیف</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>بر روی محصول</th>
                                <th style={{ backgroundColor: 'rgb(245, 245, 245)' }}>وضعیت</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comments?.map((comment: any, index: number) => (
                                <tr key={index + 'order'}>
                                    <td>
                                        {index + 1}
                                    </td>
                                    <td>
                                        {comment.text}
                                    </td>
                                    <td>
                                        {comment.product?.name}
                                    </td>
                                    <td className="fw-bold">
                                        <button className={comment.approved == 'تایید شده' ? 'btn btn-primary font-medium' : 'btn btn-danger font-medium p-3 py-2'}>
                                            {comment.approved}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default Comments;
